/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { Acknowledgement } from '../Acknowledgement';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import Button from 'react-bootstrap/Button';
import { TweetyWidget } from '../../../../widgets/tweety-widget-react-main';
import { ItemSpecVenusWidget } from '../../../../widgets/item-spec-venus-widget-react';
import { ChannelPage } from '@/widgets/channel-page-widget-react';
import * as S from './styles';
import { RightContainer } from '../RightContainer';
import { USER_LEVEL } from '@/config/userManagement.config';
import { ApplicationFormPageService } from '../../services';
import { vappContainer, VApplication } from '@/application';
import { getWidgetData } from '../WorkPermitWidgetData';
import { Loader } from '@/components';
import { Col, Row } from 'react-bootstrap';
import { FontSlider } from '../FontSlider';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

interface IWorkPermitFormData {
  fields: any[];
  layout: any[];
  dynamicLayout?: any[];
  previewLabel?: string;
  workPermitSubLabel1?: string;
  workPermitSubLabel2?: string;
  progressBarSteps?: string[];
  validatorConfig?: any;
  successIcon?: string;
  errorIcon?: string;
  userValidatorConfig?: any;
  userFormFields: any[];
  userFormLayout: any[];
  userFormTitle: string;
}

export const RenewWorkPermitComp = ({
  workPermitFormData,
  acknowledgement,
  onAcknowledgement,
  onGoBack,
  onCloseClick,
  workPermitLabel,
  onNewWorkPermitNext,
  spinner,
  loading,
  onPayClick,
  changeStepHasError,
  _initialData,
  _stepHasError,
  onDraftSave,
  currentStep,
  draftData,
  whoami,
  onFormSubmit,
  stepChange,
  workPermitPreviewSubLabel1,
  workPermitPreviewSubLabel2,
  employeeAppliesApplicant,
  proceedInvite,
  fontScale,
  updateFontScale,

  setProceedToInvite,
  setEmployeeApplies,
  _changeCurrStep,
  touchedStatus,
  _changeTouchStatus,
  workPermitAppPageState,
  onUserDetailsSubmit,
  rightBlockContent,
  applicationNo,
  rendersave,
  onContinueClick,
  onProceedToInvite,
  citydata
}: {
  rightBlockContent?: any;
  workPermitLabel: string;
  whoami?: string;
  currentStep?: number;
  employeeAppliesApplicant?: boolean;
  proceedInvite?: boolean;
  onPayClick?(appNo: string): void;
  rendersave?: boolean;
  setEmployeeApplies?(val: any): void;
  setProceedToInvite?(val: any): void;
  _changeCurrStep?(val: any): void;
  workPermitFormData: IWorkPermitFormData;
  acknowledgement: any;
  onAcknowledgement?(data: any, type: string): void;
  onGoBack?(): void;
  stepChange?(step: number, existingFormData: any): void;
  onCloseClick(): void;
  _stepHasError?: any;
  touchedStatus?: any;
  _changeTouchStatus?(val: any): void;
  onNewWorkPermitNext?(formData: any): void;
  changeStepHasError?(err: any): void;
  spinner?: any;
  loading?: any;
  fontScale: number;
  updateFontScale?(font: number): void;

  _initialData?: any;
  onFormSubmit?(formData: any): void;
  onDraftSave?(formData: any, type: string, implicitSave?: boolean): void;
  draftData?: any;
  workPermitPreviewSubLabel1?: string;
  workPermitPreviewSubLabel2?: string;
  workPermitAppPageState?: any;
  onUserDetailsSubmit?(formData: any): void;
  applicationNo?: string;
  citydata?:any;
  onContinueClick?(): void;
  onProceedToInvite?(): void;
}) => {
  const {
    fields,
    layout,
    dynamicLayout,
    previewLabel,
    workPermitSubLabel1,
    workPermitSubLabel2,
    errorIcon,
    successIcon,
    userFormFields,

    userFormLayout,
    userFormTitle,
    userValidatorConfig,
    validatorConfig,
  } = workPermitFormData;
  const [stepHasError, setStepHasError] = useState<any>({});
  const [touched, setTouched] = useState<any>({});
  const [stateLayout, setStateLayout] = useState(layout);

  const [activeStep, setActiveStep] = useState(currentStep ?? 0);
  const [employeeApplicant, setemployeeApplicant] = useState(
    employeeAppliesApplicant ?? false
  );
  const [formFields, setFormFields] = useState<any>(
    fields[activeStep >= 3 ? activeStep - 3 : activeStep] ?? []
  );
  console.log('initialdata:', _initialData);

  const [proceedToInvite, setproceedToInvite] = useState(
    proceedInvite ?? false
  );
  useEffect(() => {
    setemployeeApplicant(employeeAppliesApplicant ?? false);
  }, [employeeAppliesApplicant]);

  useEffect(() => {
    setproceedToInvite(proceedInvite ?? false);
  }, [proceedInvite]);

  useEffect(() => {
    setStepHasError({ ..._stepHasError });
  }, [_stepHasError]);
  const [totalSteps, settotalSteps] = useState(
    whoami === 'prospective_employee'
      ? 1
      : (employeeApplicant ? 2 : proceedToInvite ? 1 : 1) + 2
  );
  useEffect(() => {
    settotalSteps(
      whoami === 'prospective_employee'
        ? 1
        : (employeeApplicant ? 2 : proceedToInvite ? 1 : 1) + 2
    );
  }, [whoami, employeeApplicant, proceedToInvite]);
  let totsteps =  whoami === 'prospective_employee'
  ? 1
  : (employeeApplicant ? 2 : proceedToInvite ? 1 : 1) + 2;

  let invitebool = proceedToInvite;
  let applicantbool = employeeApplicant;

  console.log('master->', fields, formFields, activeStep);

  const [dynamicKey, setdynamicKey] = useState('first');
  const [tempKey, settempKey] = useState('');
  useEffect(() => {
    setActiveStep(currentStep ?? 0);
  }, [currentStep]);

  const [subStep, setSubStep] = useState(activeStep >= 2 ? 2 : 0);
  const [initialData, setinitialData] = useState(
    _initialData && Object.entries(_initialData)?.length > 0
      ? _initialData
      : draftData?.data ?? {}
  );
  const [key, setkey] = useState('');
  let errorinarr: any = {};
  let errfreearr: any = {};
  let errfreearr2: any = {};
  let errfreearr3: any = {};
  const _checkLayout = (
    layoutData: any[],
    key: string,
    action: string,
    position?: string
  ) => {
    console.log(`updateInitialData : _checkLayout :`, key, layoutData);

    let _res: any[] = [];
    if (action === 'delete') {
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] !== key) {
            _res.push(item);
          }
        });
    } else if (action === 'add') {
      let isExist: boolean = false;
      layoutData.length > 0 &&
        layoutData.map((item: any) => {
          if (item?.length > 0 && item[0] === key) {
            isExist = true;
          }
        });
      if (isExist) {
        _res = layoutData;
      } else {
        if (position === 'top') {
          _res = [[key], ...layoutData];
        } else {
          _res = [...layoutData, [key]];
        }
      }
    }
    return _res;
  };
  const _getCityOptions = (data: any[]) => {
    let _options: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: string, index: number) => {
        if (item) {
          _options.push({
            label: item,
            id: item,
          });
        }
      });

    return _options;
  };
  const getcity=(parish:any)=>{
    return {parish:parish,cities: _getCityOptions(citydata?.[parish])}
  }
  useEffect(() => {
    if (spinner?.show === false && spinner?.status === 'success') {
      console.log(`on acknowledgemnt`);
      setActiveStep(activeStep + 1);
    }
  }, [spinner]);

  const generateInitLayout = (initData: any) => {
    let _layout: any = stateLayout;
    let changeInLayout = undefined;
    Object.entries(initData)?.forEach((initItem) => {
      const id = initItem?.[0],
        payload = initItem?.[1];
      dynamicItems?.map((item) => {
        if (
          id === item?.id &&
          (item?.allItems
            ? item?.allItems.filter((curr) => initData?.[curr] === 'yes')
                ?.length === 0
            : payload !== item?.payload)
        ) {
          changeInLayout = item?.step;
          _layout =
            _layout &&
            Array.isArray(_layout) &&
            _layout.length > 0 &&
            _layout.map((_item: any, index: number) => {
              return {
                ..._item,
                [item?.step]: {
                  ..._item?.[item?.step],
                  data: _checkLayout(
                    _item?.[item?.step]?.data,
                    item?.newItem,
                    'delete'
                  ),
                },
              };
            });
        } else if (id === item?.id && payload === item?.payload) {
          changeInLayout = item?.step;
          _layout =
            _layout &&
            Array.isArray(_layout) &&
            _layout.length > 0 &&
            _layout.map((_item: any, index: number) => {
              return {
                ..._item,
                [item?.step]: {
                  ..._item?.[item?.step],
                  data: _checkLayout(
                    _item?.[item?.step]?.data,
                    item?.newItem,
                    'add',
                    item?.step === 'third' ? 'top' : ''
                  ),
                },
              };
            });
        }
      });
    });
    setStateLayout(_layout);
  };

  useEffect(() => {
    console.log(
      'master->',
      fields[activeStep >= 3 ? activeStep - 3 : activeStep]
    );
    let _fields =
      fields[
        activeStep >= 3 ? activeStep - 3 : activeStep === 2 ? 1 : activeStep
      ];
    // if(USER_LEVEL.owner.includes(whoami ?? '')){
    //    _fields=_fields?.map((item:any)=>{
    //      if(item?.compProps?.id==='userEmail'){
    //       return {...item,compProps:{...item?.compProps,disabled:false,readOnly:false}}
    //      }
    //      return {...item}
    //    })
    // }
    setFormFields(_fields);
    if (activeStep === 1) {
      setemployeeApplicant(false);
      setEmployeeApplies && setEmployeeApplies(false);
      setproceedToInvite(false);
      setProceedToInvite && setProceedToInvite(false);
    }
  }, [activeStep]);

  useEffect(() => {
    if (initialData && Object.entries(initialData)?.length > 0) {
      generateInitLayout(initialData);
      setinitialData({..._initialData,...initialData});
      setkey(key + 'hi');
    } else if (_initialData && Object.entries(_initialData)?.length > 0) {
      generateInitLayout(_initialData);
      setinitialData(_initialData);
      setkey(key + 'hi');
    } else if (draftData?.data) {
      console.log('io-> ::', draftData?.data);
      setkey(key + 'hi->');
      generateInitLayout(draftData?.data);
      setinitialData(draftData?.data);
    }
  }, [draftData?.data, _initialData,initialData?.isMiddleNameChange,initialData?.isLastNameChange,initialData?.isFirstNameChange]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep, subStep]);

  useEffect(() => {
    if (spinner?.show === false && spinner?.status === 'success') {
      console.log(`on acknowledgemnt`);
      setActiveStep(activeStep + 1);
    }
  }, [spinner]);

  const onActiveStepChange = () => {
    if (activeStep === 0) {
      onGoBack && onGoBack();
    } else {
      setActiveStep(activeStep - 1);
    }
  };

  console.log('lio->', initialData);

  const _renderHeader = (isPreview: boolean) => {
    console.log(`Preview label bla:`, isPreview);
    return (
      <div className="mt-2">
        {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )}
        <h4 className="text-center">{workPermitLabel}</h4>
        <h6 className="text-center">
          {isPreview
            ? subStep >= 1
              ? workPermitPreviewSubLabel2
              : workPermitPreviewSubLabel1
            : activeStep >= 1 && activeStep < 2
            ? workPermitSubLabel2
            : workPermitSubLabel1}
        </h6>
      </div>
    );
  };

  const _renderSubmitButton = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            justifyContent: 'space-evenly',
          }}
        >
          <Button
            variant="primary"
            size="sm"
            className="ms-3"
            type="submit"
            style={{
              display: 'inline-block',
              outline: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: '600',
              borderRadius: '8px',
              padding: '14px 24px',
              border: 'none',
              marginTop: '1.5rem',
              background: 'linear-gradient(to bottom right,#2f78d1,#104382)',
              color: '#fff',
            }}
            onClick={() => {
              // onProceedToInvite && onProceedToInvite();
              invitebool=true;
              applicantbool=false;
              setproceedToInvite(true);
              setemployeeApplicant(false);
            }}
          >
            Proceed with Invite
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="ms-3"
            type="submit"
            style={{
              display: 'inline-block',
              outline: 'none',
              cursor: 'pointer',
              marginTop: '1.5rem',
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: '600',
              borderRadius: '8px',
              padding: '14px 24px',
              border: 'none',
              background: 'linear-gradient(to bottom right,#2f78d1,#104382)',
              color: '#fff',
            }}
            onClick={() => {
              // onContinueClick && onContinueClick();
              applicantbool=true;
              invitebool=false;
              setemployeeApplicant(true);
              setproceedToInvite(false);
            }}
          >
            Continue with applicant form
          </Button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setdynamicKey('first');
  }, [activeStep]);

  const changeTouchStatus = (data: any, key: string) => {
    setTouched({ ...touched, [`${activeStep}-${dynamicKey}`]: true });

    console.log('pok->', tempKey, dynamicKey);
    settempKey(key);
  };
  useEffect(() => {
    if (
      formFields?.length > 0 &&
      (initialData['byAdvertisement'] === 'yes' ||
        initialData['internalRecruitment'] === 'yes' ||
        initialData['registeredLMIS'] === 'yes')
    ) {
      let ffields = formFields.filter(
        (item: any) => item?.compProps?.id !== 'noStepTaken'
      );
      setFormFields(ffields);
    } else {
      let f = 0;
      for (let i = 0; i < formFields?.length; i++) {
        if (formFields[i]?.compProps?.id === 'noStepTaken') {
          f = 1;
          break;
        }
      }
      f == 0 &&
        formFields?.length > 0 &&
        setFormFields([
          ...formFields,
          {
            type: 'textarea',
            compProps: {
              rows: 1,
              label: 'If no step was taken please state reason',
              id: 'noStepTaken',
              placeholder: 'Please state reason for not taking any step',
              required: true,
            },
          },
        ]);
    }
  }, [
    tempKey,
    initialData['byAdvertisement'],
    initialData['internalRecruitment'],
    initialData['registeredLMIS'],
  ]);

  useEffect(() => {
    if (touched[`${activeStep}-${dynamicKey}`] && tempKey !== dynamicKey) {
      console.log(
        'pok->',
        tempKey,
        'pok->',
        dynamicKey,
        'pok',
        tempKey ?? 'first'
      );
      setdynamicKey(tempKey ? tempKey : 'first');
    }
  }, [touched]);

  const _renderRightContainer = () => {
    return (
      <Col lg={6} md={5} sm={12}>
        <RightContainer rightBlockContent={rightBlockContent?.userInviteInfo} />
      </Col>
    );
  };

  const tempData: any = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
  };
  // useEffect(()=>console.log("demochck-->",formFields,initialData))
  useEffect(() => {
    initialData['occupation'] &&
      tempKey == 'third' &&
      activeStep === 1 &&
      updateMinimumWage('occupation', initialData['occupation']);
  }, [tempKey]);
  // useEffect(()=>console.log("34982758342795-----state",initialData,formFields));
  useEffect(() => {
    console.log('qwerty', activeStep, dynamicKey, tempKey);
    if (initialData['businessParish'] && initialData['mailingParish']) {
      activeStep === 1 &&
        dynamicKey === 'first' &&
        updateCityParish(
          'businessParish',
          initialData['businessParish'],
          fields[1],
          'mailingParish',
          initialData['mailingParish']
        );
    } else {
      initialData['businessParish'] &&
        activeStep === 1 &&
        dynamicKey === 'first' &&
        updateCityParish(
          'businessParish',
          initialData['businessParish'],
          fields[1]
        );
      initialData['mailingParish'] &&
        activeStep === 1 &&
        dynamicKey === 'first' &&
        updateCityParish(
          'mailingParish',
          initialData['mailingParish'],
          fields[1]
        );
    }
    initialData['employerParish'] &&
      activeStep === 3 &&
      dynamicKey === 'second' &&
      updateCityParish(
        'employerParish',
        initialData['employerParish'],
        fields[0]
      );
    initialData['parish'] &&
      activeStep === 3 &&
      dynamicKey === 'first' &&
      updateCityParish(
        'parish',
        initialData['parish'],
        fields[0]
      );
      console.log("employerParishDep-->activestep",activeStep,whoami,dynamicKey,initialData['employerParishDep'])
    initialData['employerParishDep'] &&
      ((activeStep === 0 && whoami==='prospective_employee') || (activeStep===3 && whoami!=='prospective_employee')) &&
      dynamicKey === 'first' &&
      updateCityParish(
        'employerParishDep',
        initialData['employerParishDep'],
        fields[0]
      );
  }, [dynamicKey, activeStep]);
  const updateCityParish = async (
    id: any,
    payload: any,
    formlayout: any,
    id2?: any,
    payload2?: any
  ) => {
    console.log(`8-> #2: `, id, payload, formFields);
    if (id2 && payload2) {
      // const resp1 = await getSrv().agent.getCities(payload);
      // const resp2 = await getSrv().agent.getCities(payload2);
      const resp1 = getcity(payload);
      const resp2 = getcity(payload2);
      if (resp1 && resp2) {
        let _fieldss: any = formlayout.map((item: any, index: number) => {
          if (
            id === 'businessParish' &&
            item?.compProps?.id === 'businessCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: resp1?.cities,
              },
            };
          }
          if (
            id2 === 'mailingParish' &&
            item?.compProps?.id === 'mailingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: resp2?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });
        setFormFields(_fieldss);
        return;
      }
    }
    if (
      id === 'businessParish' ||
      id === 'mailingParish' ||
      id === 'employerParish' ||
      id === 'employerParishDep' ||
      id === 'parish'
    ) {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      const _response = getcity(payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formlayout.map((item: any, index: number) => {
          if (
            id === 'businessParish' &&
            item?.compProps?.id === 'businessCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'mailingParish' &&
            item?.compProps?.id === 'mailingCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'employerParish' &&
            item?.compProps?.id === 'employerCity'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (id === 'parish' && item?.compProps?.id === 'city') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'employerParishDep' &&
            item?.compProps?.id === 'employerCityDep'
          ) {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
        console.log(`8-> :: #3 ;owirhfwoirf`, _fields);
      }
    }
    // dynamicItems?.map((item) => {
    //   if (id === item?.id && payload !== item?.payload) {
    //     _layout =
    //       _layout &&
    //       Array.isArray(_layout) &&
    //       _layout.length > 0 &&
    //       _layout.map((_item: any, index: number) => {
    //         return {
    //           ..._item,
    //           second: {
    //             ..._item?.second,
    //             data: _checkLayout(
    //               _item?.second?.data,
    //               item?.newItem,
    //               'delete'
    //             ),
    //           },
    //         };
    //       });
    //   } else if (id === item?.id && payload === item?.payload) {
    //     _layout =
    //       _layout &&
    //       Array.isArray(_layout) &&
    //       _layout.length > 0 &&
    //       _layout.map((_item: any, index: number) => {
    //         return {
    //           ..._item,
    //           second: {
    //             ..._item?.second,
    //             data: _checkLayout(_item?.second?.data, item?.newItem, 'add'),
    //           },
    //         };
    //       });
    //   }
    // });
    // setStateLayout(_layout);
    // if (initialData?.[id] !== payload) {
    //   setinitialData({ ...initialData, [id]: payload });
    // }
  };
  const updateMinimumWage = async (id: any, payload: any) => {
    const resp = await getSrv().agent.getMinimumWage(payload);
    console.log('minimumwage-->', resp);
    console.log('minimumwage--->fileds', fields[0]);
    let _ffields = fields[1].map((item: any, index: number) => {
      if (item?.compProps?.id === 'noStepTaken') {
        if (
          initialData['byAdvertisement'] === 'yes' ||
          initialData['internalRecruitment'] === 'yes' ||
          initialData['registeredLMIS'] === 'yes'
        ) {
          return null;
        } else {
          return { ...item };
        }
      } else if (
        id === 'occupation' &&
        item?.compProps?.id === 'salaryOffered'
      ) {
        // if (
        //   !initialData['salaryOffered'] ||
        //   initialData['salaryOffered'] < resp?.minimumWage
        // ) {
        //   // console.log("minimumwage00007869789788679--->imin",initialData['salaryOffered'],initialData);
        //   setinitialData({ ...initialData, salaryOffered: resp?.minimumWage });
        // }
        return {
          ...item,
          compProps: {
            ...item?.compProps,
            min: resp?.minimumWage,
            // options: resp1?.cities,
          },
        };
      } else {
        return { ...item };
      }
    });
    console.log('34982758342795____fields', _ffields);
    setFormFields(_ffields);
  };

  const dynamicItems = [
    // {
    //   id: 'maritalStatus',
    //   payload: 'married',
    //   step: 'second',
    //   newItem: 'isHusbandWifeWorkedInJamaica',
    // },
    {
      id: 'isLastNameChange',
      payload: 'yes',
      step: 'third',
      newItem: 'isNameSupport',
      allItems: ['isFirstNameChange', 'isLastNameChange', 'isMiddleNameChange'],
    },
    {
      id: 'isFirstNameChange',
      payload: 'yes',
      step: 'third',
      newItem: 'isNameSupport',
      allItems: ['isFirstNameChange', 'isLastNameChange', 'isMiddleNameChange'],
    },
    {
      id: 'isMiddleNameChange',
      payload: 'yes',
      step: 'third',
      newItem: 'isNameSupport',
      allItems: ['isFirstNameChange', 'isLastNameChange', 'isMiddleNameChange'],
    },
  ];

  console.log('ino->', initialData);

  const updateInitialData = async (id: any, payload: any) => {
    console.log(`8-> #2: `, id, payload, formFields);
    let city:any = null;
    let _layout: any = stateLayout;
    if (
      (id === 'businessParish' ||
      id === 'parish' ||
        id === 'mailingParish' ||
        id === 'employerParish' ||
        id === 'employerParishDep') &&
      (((activeStep === 1 || (activeStep===0 && whoami==='prospective_employee')) && dynamicKey === 'first') ||
        (activeStep === 3 &&
          (dynamicKey === 'second' || dynamicKey === 'first')))
    ) {
      //onParishChange && onParishChange({ ...initialData, [id]: payload });
      console.log('log->', activeStep, tempKey, dynamicKey);
      // const _response = await getSrv().agent.getCities(payload);
      const _response = getcity(payload);
      console.log(`response from parish ::`, _response);
      if (_response) {
        let _fields: any = formFields.map((item: any, index: number) => {
          if (
            id === 'businessParish' &&
            item?.compProps?.id === 'businessCity'
          ) {
            city = item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'mailingParish' &&
            item?.compProps?.id === 'mailingCity'
          ) {
            city = item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'employerParish' &&
            item?.compProps?.id === 'employerCity'
          ) {
            city = item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          }else if (
            id === 'parish' &&
            item?.compProps?.id === 'city'
          ) {
            city = item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else if (
            id === 'employerParishDep' &&
            item?.compProps?.id === 'employerCityDep'
          ) {
            city = item?.compProps?.id;
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _response?.cities,
              },
            };
          } else {
            return {
              ...item,
            };
          }
        });

        setFormFields(_fields);
        console.log(`8-> :: #3 ;jram`,_fields, formFields);
      }
    }
    // dynamicItems?.map((item) => {
    //   if (id === item?.id && payload !== item?.payload) {
    //     _layout =
    //       _layout &&
    //       Array.isArray(_layout) &&
    //       _layout.length > 0 &&
    //       _layout.map((_item: any, index: number) => {
    //         return {
    //           ..._item,
    //           second: {
    //             ..._item?.second,
    //             data: _checkLayout(
    //               _item?.second?.data,
    //               item?.newItem,
    //               'delete'
    //             ),
    //           },
    //         };
    //       });
    //   } else if (id === item?.id && payload === item?.payload) {
    //     _layout =
    //       _layout &&
    //       Array.isArray(_layout) &&
    //       _layout.length > 0 &&
    //       _layout.map((_item: any, index: number) => {
    //         return {
    //           ..._item,
    //           second: {
    //             ..._item?.second,
    //             data: _checkLayout(_item?.second?.data, item?.newItem, 'add'),
    //           },
    //         };
    //       });
    //   }
    // });
    setStateLayout(_layout);
    if (initialData?.[id] !== payload) {
      // setinitialData({ ...initialData, [id]: payload });
      setinitialData(city?{...initialData, [id]: payload, [city]: null}:{ ...initialData, [id]: payload });
    }
  };

  console.log('initu->', initialData);

  const objectsHaveSamePropertiesAndValues = (obj1: any, obj2: any) => {
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key) && obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  };

  const _renderBody = () => {
    console.log('8->', activeStep, totalSteps);

    if (activeStep === totsteps) {
      return (
        <>
          {_renderHeader(true)}
          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData(
              fields,
              initialData,
              USER_LEVEL.owner.includes(whoami ?? '')
            )}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              onAcknowledgement &&
                onAcknowledgement(initialData, 'RENEW_WORK_PERMIT');
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            whoAmI={whoami}
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep >= totsteps + 1) {
      return (
        <Acknowledgement
          {...acknowledgement}
          applicationNo={applicationNo}
          onPayClick={onPayClick}
          submitBtnText={
            USER_LEVEL.owner.includes(whoami ?? '') && !proceedToInvite
              ? acknowledgement?.submitBtnText
              : ''
          }
        />
      );
    }
    if (activeStep < totsteps) {
      if (activeStep === 2) {
        console.log('userFormFields', userFormFields, userFormLayout);
        //on proceed to invite
        console.log('InitialData123', initialData);
        return (
          <>
            <div
              style={{ ...S.UserFormTitleStyle, textAlign: 'center' }}
              className="mt-2"
            >
              {userFormTitle}
            </div>
            <FontSlider
              fontScale={fontScale}
              updateFontScale={updateFontScale}
            />

            <Row
              style={{ justifyContent: 'center', display: 'flex' }}
              className="bg-white rounded mt-3 tweety-form-shadow"
            >
              <Col lg={6} md={7} sm={12} style={{ padding: '20px' }}>
                <TweetyWidget
                  key={'proceedToInviteUserForm'}
                  labelColor={'#104382'}
                  fields={userFormFields}
                  fontScale={fontScale}
                  layout={userFormLayout}
                  validatorConfig={userValidatorConfig}
                  initialData={_initialData}
                  submitButtonLabel="Next"
                  renderSubmitButton={_renderSubmitButton}
                  onFormSubmit={(payload: any) => {
                    console.log('payload', payload);
                    setinitialData({ ...initialData, ...payload });
                    stepChange &&
                      stepChange(activeStep + 1, {
                        ...initialData,
                        ...payload,
                      });
                    if (applicantbool) {
                      onContinueClick && onContinueClick();
                    }
                    if (invitebool) {
                      onProceedToInvite && onProceedToInvite();
                    }
                    onUserDetailsSubmit && onUserDetailsSubmit(payload);
                  }}
                />
              </Col>
              {_renderRightContainer()}
            </Row>
          </>
        );
      }
      console.log(
        'layout--renew',
        layout[activeStep >= 3 ? activeStep - 3 : activeStep]
      );
      const profileData = {
        isLargeTitle: true,
        navItems: Object.entries(
          layout[activeStep >= 3 ? activeStep - 3 : activeStep]
        )?.map((_item: any) => {
          console.log('layout--renew--item', _item);
          return {
            key: _item[0],
            title: (
              <>
                {stepHasError[`${activeStep}-${_item[0]}`] === true && (
                  /* @ts-ignore */

                  <S.Img src={errorIcon} fontScale={fontScale} />
                )}
                {(stepHasError[`${activeStep}-${_item[0]}`] === false ||
                  (stepHasError[`${activeStep}-${_item[0]}`] === undefined &&
                    touched[`${activeStep}-${_item[0]}`])) && (
                  /* @ts-ignore */

                  <S.Img src={successIcon} fontScale={fontScale} />
                )}
                {_item[1]?.label}
              </>
            ),
            link: `/${_item[0]}`,
            type: 'navbar',
          };
        }),
      };

      if (Object.entries(initialData)?.length > 23) {
        console.log('InitialData123', initialData);
        console.log(`formFields :: #3 ;`, formFields);
        console.log('layout--renew--profile', { ...profileData });
        return (
          <>
            {_renderHeader(false)}
            <FontSlider
              fontScale={fontScale}
              updateFontScale={updateFontScale}
            />

            <div style={{ justifyContent: 'center', display: 'flex' }}>
              <div style={{ width: '80%' }}>
                <div className="bg-white rounded tweety-form-shadow">
                  {/* @ts-ignore */}
                  <ChannelPage
                    {...profileData}
                    activeKey={dynamicKey}
                    fontScale={fontScale}
                    isNoProfileExist={true}
                    onNavItemClick={(key: string) => {
                      changeTouchStatus(initialData, key);
                      settempKey(key);
                    }}
                  />
                  <TweetyWidget
                    labelColor={'#104382'}
                    fields={formFields}
                    allTouched={touched}
                    fontScale={fontScale}
                    key={`${
                      activeStep >= 3 ? activeStep - 3 : activeStep
                    }-${dynamicKey}`}
                    touchedStatus={!!touched[`${activeStep}-${dynamicKey}`]}
                    onUpdateDynamicLayData={(data: any) =>
                      setinitialData({ ...initialData, ...data })
                    }
                    onErrorFree={() => {
                      if (
                        stepHasError[`${activeStep}-${dynamicKey}`] ||
                        stepHasError[`${activeStep}-${dynamicKey}`] ===
                          undefined
                      ) {
                        setStepHasError({
                          ...stepHasError,
                          [`${activeStep}-${dynamicKey}`]: false,
                        });
                        changeStepHasError &&
                          changeStepHasError({
                            ...stepHasError,
                            [`${activeStep}-${dynamicKey}`]: false,
                          });
                      }
                    }}
                    // issue fixed
                    // renderSubmitButton={_renderSubmitButton}
                    onHandleError={(val) => {
                      setStepHasError({
                        ...stepHasError,
                        [`${activeStep}-${dynamicKey}`]: val,
                      });
                      changeStepHasError &&
                        changeStepHasError({
                          ...stepHasError,
                          [`${activeStep}-${dynamicKey}`]: val,
                        });
                    }}
                    initialData={initialData}
                    layout={
                      stateLayout[
                        activeStep >= 3
                          ? activeStep - 3
                          : activeStep === 2
                          ? 1
                          : activeStep
                      ]?.[dynamicKey]?.data
                    }
                    dynamicLayout={dynamicLayout}
                    onChange={(id, payload) => {
                      updateInitialData(id, payload);
                      if (id === 'occupation') {
                        // let _paylod = payload.split(':')[1];
                        console.log('idpayload->', id, payload);
                        updateMinimumWage(id, payload);
                        // const resp= await getSrv().agent.getCities(payload);
                      }
                    }}
                    validatorConfig={validatorConfig}
                    onFormSubmit={(payload: any) => {
                      let layoutarr =
                        Object.keys(
                          layout[
                            activeStep >= 3
                              ? activeStep - 3
                              : activeStep === 2
                              ? 1
                              : activeStep
                          ]
                        ) || [];
                      let len = Object.keys(
                        layout[
                          activeStep >= 3
                            ? activeStep - 3
                            : activeStep === 2
                            ? 1
                            : activeStep
                        ]
                      )?.length;
                      console.log('jeyaram->stepdata->length->', len);
                      for (let i = 0; i < len; i++) {
                        // if(i===0){
                        //   errorinarr={};
                        //   errfreearr={};
                        //   errfreearr2={};
                        //   errfreearr3={};
                        //   // setStepHasError({});
                        // }
                        errorinarr = {
                          ...errorinarr,
                          [`${activeStep}-${layoutarr[i]}`]: true,
                        };
                        errfreearr = {
                          ...errfreearr,
                          [`${activeStep}-${layoutarr[i]}`]: false,
                        };
                        errfreearr2 = {
                          ...errfreearr2,
                          [`${activeStep}-${layoutarr[i]}`]: false,
                        };
                        if (i != len - 1)
                          errfreearr3 = {
                            ...errfreearr3,
                            [`${activeStep}-${layoutarr[i]}`]: false,
                          };

                        // errorarr = {...errorarr,[`${activeStep}-${Object.keys(layout[
                        //   activeStep >= 3
                        //     ? activeStep - 3
                        //     : activeStep === 2
                        //     ? 1
                        //     : activeStep
                        // ])}`]:'false'}
                        console.log('jeyaramerrorarr->count', i);
                      }
                      errfreearr2[
                        Object.keys(errfreearr)[
                          Object.keys(errfreearr)?.length - 1
                        ]
                      ] = true;
                      console.log('jeyaram->stepdata->errorarr->', errorinarr);
                      console.log(
                        'jeyaram->stepdata->errfreearr->',
                        errfreearr
                      );
                      console.log(
                        'jeyaram->stepdata->errfreearr2->',
                        errfreearr2
                      );
                      console.log(
                        'jeyaram->stepdata->errfreearr3->',
                        errfreearr3
                      );
                      console.log(
                        'jeyaram->stepdata->err->',
                        Object.keys(errfreearr)[
                          Object.keys(errfreearr)?.length - 1
                        ]
                      );

                      // setStepHasError({...errorinarr,stepHasError});
                      // stephavingerr = {...errorinarr,...stephavingerr};
                      console.log('idpayload->', payload);
                      let flg = false;
                      console.log(
                        'steperr&&freeerr',
                        stepHasError,
                        errfreearr3
                      );
                      //   if(tempKey===layoutarr[layoutarr?.length - 1]){
                      //   for(let i=0;i<errfreearr3.length;i++){
                      //     console.log("jeyaramifcase",(Object.keys(stepHasError).includes(Object.keys(errfreearr3)[i]) && stepHasError[errfreearr3[i]]===false));
                      //     if(Object.keys(stepHasError).includes(Object.keys(errfreearr3)[i]) && stepHasError[errfreearr3[i]]===false){}
                      //     else{
                      //       flg=true;
                      //       return;
                      //     }
                      //   }
                      // }
                      // if(tempKey===layoutarr[layoutarr?.length - 1] && flg){
                      //   return;
                      // }
                      // let errorarr = {};
                      // let len = layout[
                      //   activeStep >= 3
                      //     ? activeStep - 3
                      //     : activeStep === 2
                      //     ? 1
                      //     : activeStep
                      // ]?.length;
                      // for(let i=0;i<len;i++){
                      //   errorarr = {...errorarr,[`${activeStep}-${Object.keys(layout[
                      //     activeStep >= 3
                      //       ? activeStep - 3
                      //       : activeStep === 2
                      //       ? 1
                      //       : activeStep
                      //   ])[i]}`]:'false'}
                      //   console.log("jeyaramerrorarr->count",i);
                      // }
                      // console.log("jeyaramerrorarr->",errorarr);
                      // setStepHasError({...errorinarr,stepHasError});
                      if (
                        ((activeStep == 1 && whoami === 'owner') ||
                          (activeStep === 0 && whoami !== 'owner')) &&
                        tempKey === layoutarr[layoutarr?.length - 1] &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr,
                          stepHasError
                        ) &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr2,
                          stepHasError
                        ) &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr3,
                          stepHasError
                        )
                      ) {
                        console.log('vanthuten...', tempKey, stepHasError);
                        return;
                      }
                      if (
                        activeStep == 3 &&
                        tempKey === layoutarr[layoutarr?.length - 1] &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr,
                          stepHasError
                        ) &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr2,
                          stepHasError
                        ) &&
                        !objectsHaveSamePropertiesAndValues(
                          errfreearr3,
                          stepHasError
                        )
                      ) {
                        console.log('vanthuten...2', tempKey, stepHasError);
                        return;
                      }
                      const formData = { ...initialData, ...payload };
                      setinitialData({ ...formData });
                      onDraftSave &&
                        onDraftSave(formData, 'RENEW_WORK_PERMIT', true);
                      console.log('oops->', formData);
                      console.log(`testing bla ::`, activeStep, totalSteps);
                      if (
                        Object.entries(
                          layout[
                            activeStep >= 3
                              ? activeStep - 3
                              : activeStep === 2
                              ? 1
                              : activeStep
                          ]
                        )?.length === tempData[dynamicKey]
                      ) {
                        // if (activeStep === totalSteps - 1) {
                        const allTouched = Object.entries(touched)?.filter(
                          (item) => !!item[1]
                        );
                        const allErrors = Object.entries(stepHasError)?.filter(
                          (item) => item[1]
                        );
                        let newTouched: any = {};
                        console.log('ho->', allTouched, allErrors);
                        const total = Object.entries(
                          layout[
                            activeStep >= 3
                              ? activeStep - 3
                              : activeStep === 2
                              ? 1
                              : activeStep
                          ]
                        )?.length;
                        console.log(
                          'ho->so',
                          allTouched,
                          allErrors,
                          allTouched.length,
                          total,
                          total - (touched[dynamicKey] ? 0 : 1)
                        );
                        if (
                          allErrors?.length === 0 ||
                          allTouched.length ===
                            total -
                              (touched[`${activeStep}-${dynamicKey}`] ? 0 : 1)
                        ) {
                          console.log('ho->');
                          Object.entries(
                            layout[
                              activeStep >= 3
                                ? activeStep - 3
                                : activeStep === 2
                                ? 1
                                : activeStep
                            ]
                          )?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                          });
                          _changeTouchStatus && _changeTouchStatus(newTouched);
                          setTouched({ ...newTouched });
                          settempKey('first');
                          changeStepHasError &&
                            changeStepHasError({
                              ...stepHasError,
                              [`${activeStep}-${dynamicKey}`]: false,
                            });
                          onFormSubmit && onFormSubmit({ ...formData });
                          stepChange &&
                            stepChange(activeStep + 1, { ...formData });
                          setActiveStep((activeStep) => activeStep + 1);
                        } else {
                          console.log('ho->');
                          let newTouched: any = {};

                          let err: any = {};
                          Object.entries(
                            layout[
                              activeStep >= 3
                                ? activeStep - 3
                                : activeStep === 2
                                ? 1
                                : activeStep
                            ]
                          )?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                            if (!touched[`${activeStep}-${item[0]}`]) {
                              if (
                                key ===
                                Object.entries(
                                  layout[
                                    activeStep >= 3
                                      ? activeStep - 3
                                      : activeStep === 2
                                      ? 1
                                      : activeStep
                                  ]
                                )?.length -
                                  1
                              ) {
                                err[`${activeStep}-${item[0]}`] = false;
                              } else {
                                err[`${activeStep}-${item[0]}`] = true;
                              }
                            }
                          });
                          setTouched(newTouched);
                          // console.log('ho->',stepHasError,err,{...stepHasError,...err});
                          setStepHasError({ ...stepHasError, ...err });
                          changeStepHasError &&
                            changeStepHasError({ ...stepHasError, ...err });
                          settempKey('first');
                          window.scrollTo(0, 0);
                        }
                        //   if (
                        //     activeStep == 2 &&
                        //     dynamicKey == 'second' &&
                        //     tempKey == 'second'
                        //   ) {
                        //     // setActiveStep(3);
                        //     _changeCurrStep && _changeCurrStep(3);
                        //     // setCurrentStep(currentStep+1);
                        //     settempKey(tempKey + 1);
                        //   }
                        // } else {
                        //   // setActiveStep(activeStep + 1);
                        //   // _changeCurrStep && _changeCurrStep(activeStep + 1);
                        //   stepChange &&
                        //     stepChange(activeStep + 1, { ...formData });
                        //   console.log('ho->');
                        // }
                      } else {
                        const ans = Object.entries(
                          layout[
                            activeStep >= 3
                              ? activeStep - 3
                              : activeStep === 2
                              ? 1
                              : activeStep
                          ]
                        )?.map((_item) => _item?.[0]);
                        const key = ans.indexOf(dynamicKey);
                        const temp = Object.entries(
                          layout[
                            activeStep >= 3
                              ? activeStep - 3
                              : activeStep === 2
                              ? 1
                              : activeStep
                          ]
                        )?.[key + 1]?.[0];
                        setStepHasError({
                          ...stepHasError,
                          [`${activeStep}-${dynamicKey}`]: false,
                        });
                        changeStepHasError &&
                          changeStepHasError({
                            ...stepHasError,
                            [`${activeStep}-${dynamicKey}`]: false,
                          });
                        changeTouchStatus(initialData, temp);
                        window.scroll(0, 0);
                      }
                    }}
                    submitButtonLabel={'Next'}
                    renderSaveButton={rendersave ? false : true}
                    onDraftSave={(data) =>
                      onDraftSave && onDraftSave(data, 'RENEW_WORK_PERMIT')
                    }
                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  };
  if (spinner?.show) {
    return <Loader {...loading} />;
  }
  return <>{_renderBody()}</>;
};

RenewWorkPermitComp.defaultProps = {
  loading: {
    image: '',
    titleNormalText: 'Submitting application',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  workPermitPreviewSubLabel1: 'Confirm  Details',
  workPermitPreviewSubLabel2: 'Confirm  Details',
};
